/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Sample_Meta_TitleInputs */

const ja_playdata_sample_meta_title = /** @type {(inputs: Playdata_Sample_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンプルレポート`)
};

const en_playdata_sample_meta_title = /** @type {(inputs: Playdata_Sample_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Sample Report`)
};

/**
* | output |
* | --- |
* | "Free Sample Report" |
*
* @param {Playdata_Sample_Meta_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_sample_meta_title = /** @type {((inputs?: Playdata_Sample_Meta_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Sample_Meta_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_sample_meta_title(inputs)
	return en_playdata_sample_meta_title(inputs)
});